import React from "react";
import getCostoCorso from "../services/getCostoCorso";
import Cookies from "universal-cookie";
import moment from "moment";
import generateExcel from "../services/generateExcel";
import Constants from "../utils/consts";

export default class CostoCorsoDialog extends React.Component {

    constructor(props){
        super(props);

        this.state = {
            costo: null,
            loading: false,
            materie: null,
            selection: 0,
        }
    }

    async componentDidMount() {
        if (!this.props.corso) {
            this.close()
            return
        }
        const cookies = new Cookies();
        const username = cookies.get('username', { path: '/' });
        const token = cookies.get('token', { path: '/' });
        const costo = await getCostoCorso(username, token, this.props.corso)
        console.log(costo);
        if (!costo) {
            this.close()
            return
        }
        this.setState({ costo: costo.insegnanti, materie: costo.materie })
    }

    close() {
        if (this.props.onClose) {
            this.props.onClose()
        }
    }

    async download() {
        this.setState({ loading: true })

        var jsonData = [];
        var materieData = [];

        jsonData.push(['Corso:', this.props.nome]);
        jsonData.push(['', '']);
        jsonData.push(['Insegnante', 'Ore']);

        materieData.push(['Corso:', this.props.nome]);
        materieData.push(['', '']);
        materieData.push(['Materia', 'Ore']);

        this.state.costo.forEach(insegnante => {
            jsonData.push([insegnante.cognome + ' ' + insegnante.nome, insegnante.ore]);
        });
        
        this.state.materie.forEach(materia => {
            materieData.push([materia.materia, materia.ore]);
        });

        jsonData.push(['', '']);
        jsonData.push(['Data di creazione report:', moment().format('DD/MM/yyyy HH:mm')]);

        var jsonTabs = [];
        jsonTabs.push({
            name: 'Insegnanti',
            data: jsonData
        });

        jsonTabs.push({
            name: 'Materie',
            data: materieData
        });

        var json = {
            tabs : jsonTabs
        };

        const cookies = new Cookies();
        const username = cookies.get('username', { path: '/' });
        const token = cookies.get('token', { path: '/' });
        await generateExcel(username, token, JSON.stringify(json), 'costo_corso');
        
        window.open(`https://${Constants.mainUrl}pdf/costo_corso.xlsx`, '_blank');
        this.setState({ loading: false });
    }

    render (){

        return ( 

            <div> 
                <div style={container} onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.close();
                }}>
                    <div style={mainClass}>
                        <p style={{ position: 'absolute', top: 10, right: 20, cursor: 'pointer' }} onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            this.close();
                        }}>X</p>
                        <div onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                        }} style={{ flexDirection: 'row', display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
                            <h2 style={{ fontWeight: this.state.selection === 0 ? 'bold' : 'normal', cursor: 'pointer' }} onClick={() => this.setState({ selection: 0 })}>Ore insegnanti</h2>
                            <h2 style={{ fontWeight: this.state.selection === 1 ? 'bold' : 'normal', cursor: 'pointer', marginLeft: 30 }} onClick={() => this.setState({ selection: 1 })}>Ore materie</h2>
                        </div>
                        {this.state.costo === null && <h3>Calcolo in corso...</h3>}
                        {this.state.costo !== null && (
                            <>
                                <h3>Calcolo costo per il corso: {this.props.nome}</h3>
                                {this.state.selection === 0 ? (
                                    <div style={{ maxHeight: '80%', overflow: 'scroll', width: '80%' }}>
                                        <table style={{ width: '100%', border: '1px solid grey', borderCollapse: 'collapse' }}>
                                            <tr style={{ border: '1px solid grey', borderCollapse: 'collapse' }}>
                                                <td style={{ paddingTop: 5, paddingBottom: 5, paddingLeft: 20, paddingRight: 20 }}><b>Insegnante</b></td>
                                                <td style={{ textAlign: 'right', paddingTop: 5, paddingBottom: 5, paddingLeft: 20, paddingRight: 20 }}><b>Ore inserite</b></td>
                                            </tr>
                                            {this.state.costo.map((costo) => (
                                                <tr key={Math.random()} style={{ border: '1px solid grey', borderCollapse: 'collapse' }}>
                                                    <td style={{ paddingTop: 5, paddingBottom: 5, paddingLeft: 20, paddingRight: 20 }}>{costo.cognome} {costo.nome}</td>
                                                    <td style={{ textAlign: 'right', paddingTop: 5, paddingBottom: 5, paddingLeft: 20, paddingRight: 20 }}>{costo.ore}</td>
                                                </tr>
                                            ))}
                                        </table>
                                    </div>
                                ) : (
                                    <div style={{ maxHeight: '80%', overflow: 'scroll', width: '80%' }}>
                                        <table style={{ width: '100%', border: '1px solid grey', borderCollapse: 'collapse' }}>
                                            <tr style={{ border: '1px solid grey', borderCollapse: 'collapse' }}>
                                                <td style={{ paddingTop: 5, paddingBottom: 5, paddingLeft: 20, paddingRight: 20 }}><b>Materia</b></td>
                                                <td style={{ textAlign: 'right', paddingTop: 5, paddingBottom: 5, paddingLeft: 20, paddingRight: 20 }}><b>Ore inserite</b></td>
                                            </tr>
                                            {this.state.materie.map((materia) => (
                                                <tr key={Math.random()} style={{ border: '1px solid grey', borderCollapse: 'collapse' }}>
                                                    <td style={{ paddingTop: 5, paddingBottom: 5, paddingLeft: 20, paddingRight: 20 }}>{materia.materia}</td>
                                                    <td style={{ textAlign: 'right', paddingTop: 5, paddingBottom: 5, paddingLeft: 20, paddingRight: 20 }}>{materia.ore}</td>
                                                </tr>
                                            ))}
                                        </table>
                                    </div>
                                )}
                                <h4 onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    this.download();
                                
                                }}
                                style={{ cursor: 'pointer' }}>{ this.state.loading ? 'Caricamento...' : 'Scarica Excel'}</h4>
                            </>
                        )}
                    </div>
                </div>
            </div>
        )
    }


}

const mainClass = {
    display: 'flex', 
    flexDirection: 'column', 
    justifyContent: 'center', 
    alignItems: 'center',
    border: '1px solid black',
    background: '#ffffff',
    padding: '30px',
    width: '60%',
    maxHeight: '80%',
    position: 'relative',
}

const container = {
    position: 'fixed',
    width: '100%',
    height: '100%',
    display: 'flex', 
    flexDirection: 'row',
    justifyContent: 'center', 
    alignItems: 'center',
    top: 0,
    left: 0,
    background: '#ffffff88',
    zIndex: 10000, 
}